'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var toUrlSearchParams = require('../../../lib/to-url-search-params.js');

var utils = require('./utils.js');

function createAdd(client) {
  function add(_x, _x2) {
    return _add.apply(this, arguments);
  }

  function _add() {
    _add = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(name, options) {
      var endpoint, key, headers, timeout, signal;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              endpoint = options.endpoint, key = options.key, headers = options.headers, timeout = options.timeout, signal = options.signal;
              _context.next = 3;
              return client.post('pin/remote/service/add', {
                timeout: timeout,
                signal: signal,
                searchParams: toUrlSearchParams.toUrlSearchParams({
                  arg: [name, utils.encodeEndpoint(endpoint), key]
                }),
                headers: headers
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _add.apply(this, arguments);
  }

  return add;
}

exports.createAdd = createAdd;